import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../index'

interface NavigationState {
  beforePath: string | null
  twitterLogin: boolean
}

const initialState: NavigationState = {
  beforePath: null,
  twitterLogin: false,
}

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setBeforePath: (state, action: PayloadAction<string>) => {
      state.beforePath = action.payload
    },
    clearBeforePath: (state) => {
      state.beforePath = null
    },
    setTwitterLogin: (state, action: PayloadAction<boolean>) => {
      state.twitterLogin = action.payload
    },
    clearTwitterLogin: (state) => {
      state.twitterLogin = false
    },
  },
})

export const { setBeforePath, clearBeforePath, setTwitterLogin, clearTwitterLogin } =
  navigationSlice.actions

export const selectBeforePath = (state: RootState) => state.navigation.beforePath
export const selectTwitterLogin = (state: RootState) => state.navigation.twitterLogin

export default navigationSlice.reducer
